var render = function render(){var _vm=this,_c=_vm._self._c;return _c('plugin-layout',[_c('div',[_c('plugin-editions',{attrs:{"plugin":_vm.plugin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }